import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";

import {
    Layout,
    Table,
    Row,
    Typography,
    Card,
    Select,
    Form,
    DatePicker,
    Col,
    InputNumber,
    Divider,
    Button,
    Modal,
    Descriptions,
    Spin
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";

import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";
import appStatic from '../../../../../../config/appStatic';

const { Text } = Typography

const columns = [
    {
        title: "Entry Id",
        dataIndex: "id",
    },

    {
        title: "Type",
        dataIndex: "type",
    },
    {
        title: "Account",
        dataIndex: "account",
    },
    {
        title: "Credit",
        dataIndex: "credit",
    },
    {
        title: "Debit",
        dataIndex: "debit",
    },
];

const ViewJournalEntries = (props) => {
    const { userData } = props;
    const { session } = userData;
    const { monthList } = appStatic
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [journalEntriesDetail, setJournalEntriesDetail] = useState([]);
    const [journalEntriesList, setJournalEntriesList] = useState([]);


    useEffect(() => {
        getDetail();
    }, []);

    function getDetail() {

        const params = {
            transactionDetails: true,
            transactionId: `L${state.transactionId}`
        }
        const url = `${apiConfig.Journalentries}`

        let body = {
            session,
            params
        };

        setIsLoading(true)
        BOM.FetchReqAction(body, url, (err, res) => {

            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
            } else {
                setIsLoading(false)
                const objList = res?.pageItems;
                setJournalEntriesDetail(objList)

                let tempJournalEntryList = []

                objList?.forEach((element) => {
                    tempJournalEntryList.push({
                        key: element?.id,
                        id: element?.id,
                        type: element?.glAccountType ? element?.glAccountType?.value : "-",
                        account: element?.glAccountName ? `${element?.glAccountName}(${element?.glAccountCode})` : "-",
                        debit: element?.entryType?.value?.toLowerCase() === "debit" ? element?.amount : "-",
                        credit: element?.entryType?.value?.toLowerCase() === "credit" ? element?.amount : "-",
                    });
                });

                setJournalEntriesList(tempJournalEntryList)
            }
        });
    }

    function onCancel() {
        navigate("/detail-loan-account", { state: state });
    }


    const items = [
        {
            label: labelConfig.office,
            children: journalEntriesDetail[0] ? journalEntriesDetail[0]?.officeName : "-"
        },
        {
            label: labelConfig.createdBy,
            children: journalEntriesDetail[0] ? journalEntriesDetail[0]?.createdByUserName : "-"
        },

        {
            label: labelConfig.transactionDate,
            children: journalEntriesDetail[0]
                ? (`${journalEntriesDetail[0]?.transactionDate[2]} ${monthList[journalEntriesDetail[0]?.transactionDate[1] - 1]} ${journalEntriesDetail[0]?.transactionDate[0]}`)
                : "-"
        },
        {
            label: labelConfig.createdOn,
            children: journalEntriesDetail[0]
                ? (`${journalEntriesDetail[0]?.createdDate[2]} ${monthList[journalEntriesDetail[0]?.createdDate[1] - 1]} ${journalEntriesDetail[0]?.createdDate[0]}`)
                : "-"
        },

    ];

    return (
        <MainLayout
            isEnableRightSidebar={true}
        >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.journalEntries}
                pageItems={staticConfig.viewJournalEntriesBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form
                        form={form}
                        layout="vertical"
                        // onFinish={onSubmit}
                    >

                        <Row >

                            <Descriptions
                                bordered
                                column={{
                                    xs: 1,
                                    sm: 2,
                                    md: 2,
                                    lg: 2,
                                    xl: 2,
                                    xxl: 2,
                                }}
                                style={{ marginTop: 10, marginBottom: 20 }}
                                items={items}
                            />
                        </Row>

                        <Row>
                            <Divider orientation="left"></Divider>

                            <Col span={24} style={{ padding: "0px 8px" }}>
                                <Table
                                    columns={columns}
                                    dataSource={journalEntriesList}
                                ></Table>
                            </Col>

                        </Row>

                    </Form>
                </Card>
            </Spin>

        </MainLayout>

    )
}

export default ViewJournalEntries



